export default "__VITE_ASSET__f951ff94__"